import React from 'react';
import Form from '../../../../components/molecules/Form';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import IForm from '../../../../types/IForm';
import { AttachedFilesBaseUploadFormTemplate } from './AttachedFilesBaseUploadFormTemplate';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { AttachedFilesBaseUploadFormSendTemplate } from './AttachedFilesBaseUploadFormSendTemplate';
import { ComboBoxParam, SonForm } from '../../../Form2';

export type AttachedFilesBaseUploadForm = {
  id: string;
  fileLink: SonForm<ComboBoxParam<'fileResourceReference'>>;
  fileUpload: IForm;
};

export function AttachedFilesBaseUploadForm({ fileLink, fileUpload, id }: AttachedFilesBaseUploadForm) {
  const { t } = useSonTranslation('AttachedFiles');

  return (
    <Form
      id={id}
      model={fileUpload}
      onSuccess={(res: any, models: any[]) => {
        setTimeout(() => {
          // when we successfully uploaded a file, we need to set the input's
          // value to null and status to 'none' to be able to upload another file.
          models[0].model.status = InteractionStatus.NONE;
          models[0].model.clear(true);
        }, 2000);
      }}
      allowNavigationOnUnsavedChanges
    >
      <AttachedFilesBaseUploadFormTemplate id="file-upload-input" multiple headline={t('headline')} hierarchy={4} />
      <AttachedFilesBaseUploadFormSendTemplate submitButtonLabel={t('form.submitButtonLabel')} fileLink={fileLink} />
    </Form>
  );
}
